var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-view",class:_vm.fullscreen ? 'full-screen' : '',style:(("background: " + _vm.bgcolor + ";"))},[_c('img',{attrs:{"src":require('@assets/ic_empty.png'),"alt":""}}),_c('div',[_vm._v(" "+_vm._s(_vm.content)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }